import { render, staticRenderFns } from "./InvoiceRecognitionDetail.vue?vue&type=template&id=06cb7ca6&"
import script from "./InvoiceRecognitionDetail.vue?vue&type=script&lang=js&"
export * from "./InvoiceRecognitionDetail.vue?vue&type=script&lang=js&"
import style0 from "./InvoiceRecognitionDetail.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports